// src/utils/authHelpers.js
// Helper utilities for authentication error handling

/**
 * Handles API response errors, specifically checking for 401 Unauthorized
 * Only shows login prompt if user had a token that was rejected (expired/invalid)
 *
 * @param {Response} response - The fetch response object
 * @param {Function} setShowExpiredSessionModal - State setter for showing the modal
 * @returns {boolean} - Returns true if error was handled, false otherwise
 */
export const handleAuthError = (response, setShowExpiredSessionModal) => {
  // Only handle 401 errors
  if (response.status !== 401) {
    return false;
  }

  // Check if user had a token (meaning they were previously logged in)
  const token = localStorage.getItem("memberstackToken");

  // Only show login prompt if they had a token that got rejected
  // If no token exists, they're probably just a new visitor browsing
  if (token) {
    setShowExpiredSessionModal(true);
    return true;
  }

  return false;
};

/**
 * Component for the expired session modal
 * Shows login prompt with option to create account
 *
 * @param {boolean} show - Whether to show the modal
 * @param {Function} onLogin - Callback when user clicks login button
 * @param {Function} onCreateAccount - Callback when user clicks create account
 */
export const ExpiredSessionModal = ({ show, onLogin, onCreateAccount }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: "80px",
        zIndex: 1200,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "32px",
          borderRadius: "12px",
          textAlign: "center",
          maxWidth: "400px",
          width: "80%",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <h3 style={{
          marginBottom: "16px",
          color: "#1F2937",
          fontSize: "1.25rem",
          fontWeight: "700"
        }}>
          Session Expired
        </h3>
        <p style={{
          marginBottom: "24px",
          color: "#4B5563",
          lineHeight: "1.5"
        }}>
          Your session has expired. Please log in again to continue.
        </p>
        <button
          className="button-2 is-black w-button"
          onClick={onLogin}
          style={{
            width: "100%",
            marginBottom: "16px",
          }}
        >
          Log In
        </button>
        <p style={{
          margin: 0,
          color: "#6B7280",
          fontSize: "0.9rem"
        }}>
          New here?{" "}
          <button
            onClick={onCreateAccount}
            style={{
              background: "none",
              border: "none",
              color: "#8B5FBF",
              textDecoration: "underline",
              cursor: "pointer",
              fontSize: "0.9rem",
              fontWeight: "600",
              padding: 0,
            }}
          >
            Create an account
          </button>
        </p>
      </div>
    </div>
  );
};
